import { gql } from '@apollo/client';

export const BridgeQuery = gql`
  query BridgeInfo {
  res: bridgeInfo {
    opSystem
    system
    version
    downloadUrl
    updateUrl
    changelog
  }
}`;

export const SMARTCASES = gql`
  query SmartCases($teamId: ID!, $userId: ID!) {
    res: discoverSmartcases(teamId: $teamId, userId: $userId) {
      serial
    }
  }
`;

export const SMARTCASES_DETAILS = gql`
  query SmartCasesDetails($teamId: ID!, $userId: ID!) {
    res: discoverSmartcases(teamId: $teamId, userId: $userId) {
      devices {
        uuid
        transferProgress
        soc
        serialId
        memory
        fwVersion
        athlete
      }
      serial
      newDeviceVersion
    }
  }
`;
